import React, { Fragment } from 'react'
import DisplayRecordList from '../../../../ui/record-display-list'
import ActiveFilter from '../../../../ui/active-filter'
import {
  recordActionsToDisplay,
  RecordListActions
} from '../../../../ui/gov-actions'
import Merge from '../../merge'

import { sendEnrolmentDetails } from '../actions/send-enrolment-details'
import { updateEnrolmentSchedule } from '../actions/update-enrolment-schedule'
import { endEnrolment } from '../actions/end-enrolment'
import { confirmMatchingParent } from '../actions/confim-matching-parent'
import { createCCSEnrolment } from '../actions/create-enrolment'
import { updateEnrolmentStartDate } from '../actions/update-start-date'
import { submitDraftEnrolment } from '../actions/submit-draft-enrolment'
import { removeDraftEnrolment } from '../actions/remove-draft-enrolment'
import { draftStatus } from './helper'
import { GovRecordBadges } from './badges'
import './schedule.css'

const inActiveStatusList = [
  'approved',
  'pending',
  'pending eligibility',
  'confirmed',
  'manual',
  'received',
  'disputed',
  'draft'
]

const childName = ({ childFirstName, childMiddleName, childLastName }) =>
  [childFirstName, childMiddleName, childLastName]
    .filter((val) => val)
    .join(' ')

const parentName = ({ individualFirstName, individualLastName }) =>
  [individualFirstName, individualLastName].filter((val) => val).join(' ')

const level1 = [
  {
    label: 'Child',
    fn: childName
  },
  {
    key: 'childCRN',
    label: 'Child CRN'
  },

  {
    label: 'Parent',
    fn: parentName
  },
  {
    key: 'individualCRN',
    label: 'Parent CRN'
  }
]

const level2 = [
  {
    key: 'arrangementStartDate',
    label: 'Start date'
  },
  {
    key: 'childDateOfBirth',
    label: 'Child date of birth'
  },
  {
    key: 'individualDateOfBirth',
    label: 'Parent date of birth'
  },
  {
    key: 'serviceID',
    label: 'CSS Service ID'
  }
]

const TopContent = ({
  regHolderId,
  regHolderType,
  child,
  mergeStatus,
  refresh_ccs_gov_enrolments
}) => (
  <Fragment>
    <RecordListActions
      options={[
        createCCSEnrolment({
          regHolderId,
          regHolderType,
          child,
          refresh_enrolments: () =>
            refresh_ccs_gov_enrolments(child.ccs_enrolments_path)
        })
      ]}
    />
    <Merge {...mergeStatus} />
  </Fragment>
)

const actionsForRecord = ({
  refresh_enrolments,
  regHolderId,
  regHolderType,
  child,
}) => ({ record }) => [
  updateEnrolmentSchedule({ regHolderId, regHolderType, child, record }),
  endEnrolment({ record, refresh_enrolments }),
  confirmMatchingParent({ record }),
  sendEnrolmentDetails({
    record,
    refresh_enrolments,
  }),
  updateEnrolmentStartDate({ record, refresh_enrolments }),
  removeDraftEnrolment({ record, refresh_enrolments }),
  submitDraftEnrolment({ record, refresh_enrolments }),
];

const filterActiveRecords = ({ status }) =>
  inActiveStatusList.includes(String(status).toLowerCase())

const CCSView = ({
  records,
  mergeStatus,
  regHolderId,
  regHolderType,
  child,
  refresh_ccs_gov_enrolments
}) => {
  return (
    <ActiveFilter records={records} filterOn={filterActiveRecords}>
      <DisplayRecordList
        name='CCS Government Enrolment'
        showRaw
        pending={(record) => draftStatus(record.status)}
        records={records}
        recordBadgesComponent={GovRecordBadges}
        topContent={
          <TopContent
            {...{
              regHolderId,
              regHolderType,
              child,
              mergeStatus,
              refresh_ccs_gov_enrolments
            }}
          />
        }
        actionButtonsComponent={recordActionsToDisplay({
          actionsForRecord: actionsForRecord({
            refresh_enrolments: () =>
              refresh_ccs_gov_enrolments(child.ccs_enrolments_path),
            regHolderId,
            regHolderType,
            child
          })
        })}
        activeLabel=''
        recordBase='gov_record'
        level1={level1}
        level2={level2}
      />
    </ActiveFilter>
  )
}

export default CCSView



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/view/index.js